webpackJsonp([1],{

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(388),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TeamsByWins__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_TeamsByWins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_TeamsByWins__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_TeamsByBoundries__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_TeamsByBoundries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_TeamsByBoundries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_BatsmanTotalRuns__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_BatsmanTotalRuns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_BatsmanTotalRuns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_BatsmenIndividualScores__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_BatsmenIndividualScores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_BatsmenIndividualScores__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_BatsmenBoundries__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_BatsmenBoundries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_BatsmenBoundries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_BowlerTotalWickets__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_BowlerTotalWickets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_BowlerTotalWickets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_BowlerEconomy__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_BowlerEconomy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_BowlerEconomy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_AwardsMOTM__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_AwardsMOTM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_AwardsMOTM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_AwardsOrangeCaps__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_AwardsOrangeCaps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_AwardsOrangeCaps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_AwardsPurpleCaps__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_AwardsPurpleCaps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_AwardsPurpleCaps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_SeasonFinals__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_SeasonFinals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_SeasonFinals__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/finals',
    name: 'Finals',
    component: __WEBPACK_IMPORTED_MODULE_13__components_pages_SeasonFinals___default.a
  }, {
    path: '/team-wins',
    name: 'TeamsByWins',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_TeamsByWins___default.a
  }, {
    path: '/team-boundries',
    name: 'TeamsByBoundries',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_TeamsByBoundries___default.a
  }, {
    path: '/batsmen-total-runs',
    name: 'BatsmenTotalRuns',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_BatsmanTotalRuns___default.a
  }, {
    path: '/batsmen-individual-scores',
    name: 'BatsmenIndividualScores',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_BatsmenIndividualScores___default.a
  }, {
    path: '/batsmen-boundries',
    name: 'BatsmenBoundries',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_BatsmenBoundries___default.a
  }, {
    path: '/bowler-total-wickets',
    name: 'BowlerTotalWickets',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_BowlerTotalWickets___default.a
  }, {
    path: '/bowler-economy',
    name: 'BowlerEconomy',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_BowlerEconomy___default.a
  }, {
    path: '/awards-motm',
    name: 'AwardsMOTM',
    component: __WEBPACK_IMPORTED_MODULE_10__components_pages_AwardsMOTM___default.a
  }, {
    path: '/awards-orange-caps',
    name: 'AwardsOrangeCaps',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pages_AwardsOrangeCaps___default.a
  }, {
    path: '/awards-purple-caps',
    name: 'AwardsPurpleCaps',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_AwardsPurpleCaps___default.a
  }]
}));

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(403),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(141);
 // Fetch Polyfill





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Sidebar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_0__components_Sidebar___default.a
  },
  data: function data() {
    return {
      isSideBarOpen: false
    };
  },

  methods: {
    openSidebar: function openSidebar() {
      this.isSideBarOpen = true;
    },
    closeSidebar: function closeSidebar() {
      this.isSideBarOpen = false;
    }
  }
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loader'
});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  props: {
    isSideBarOpen: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  methods: {
    toggle: function toggleCollapse(e) {
      e.target.classList.toggle('active');
      var panel = e.target.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    },
    closeSideBar: function closeSideBar() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Loader__);
//
//
//
//
//
//
//
//
//
//





// eslint-disable-next-line



var props = {
  data: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  margin: {
    type: Object,
    default: function _default() {
      return {
        left: 30,
        right: 20,
        top: 10,
        bottom: 25
      };
    }
  },
  domain: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  barColor: {
    type: String,
    default: function _default() {
      return '#EF5350';
    }
  },
  tipLabel: {
    type: String,
    default: function _default() {
      return 'value';
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bar-chart',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_5__Loader___default.a
  },
  props: props,
  data: function data() {
    return {
      width: 0,
      height: 0,
      scales: {
        color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleOrdinal */])(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* schemeCategory10 */])
      },
      resizeTimer: null
    };
  },

  computed: {
    padded: function padded() {
      var width = this.width - this.margin.left - this.margin.right;
      var height = this.height - this.margin.top - this.margin.bottom;
      return { width: width, height: height };
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      clearTimeout(_this.resizeTimer);
      _this.resizeTimer = setTimeout(_this.onResize, 550);
    });
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    data: function dataChanged() {
      this.init();
    },
    width: function widthChanged() {
      this.initialize();
      this.update();
      this.updateChart();
    }
  },
  methods: {
    onResize: function onResize() {
      this.width = this.$el.offsetWidth;
      this.height = this.width > 480 ? 400 : 360;
    },
    initialize: function initialize() {
      this.scales.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["c" /* scaleBand */])().rangeRound([this.padded.width, 0]).padding(0.1);
      this.scales.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scaleLinear */])().rangeRound([0, this.padded.height]);
    },
    update: function update() {
      var _this2 = this;

      var maxY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["a" /* max */])(this.data, function (d) {
        return d[_this2.domain.y];
      });
      this.scales.x.domain(this.data.map(function (d) {
        return d[_this2.domain.x];
      }));
      this.scales.y.domain([maxY, 0]);
    },
    wrap: function wrap(text, width) {
      text.each(function wrapText() {
        var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this);
        var words = t.text().split(/\s+/).reverse();
        var word = words.pop();
        var line = [];
        // eslint-disable-next-line
        var lineNumber = 0;
        var lineHeight = 1;
        var y = t.attr('y');
        var dy = parseFloat(t.attr('dy'));
        var tspan = t.text(null).append('tspan').attr('x', 0).attr('y', y).attr('dy', dy + 'em');

        while (word) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            lineNumber += 1;
            tspan = t.append('tspan').attr('x', 0).attr('y', y).attr('dy', lineNumber * lineHeight + dy + 'em').text(word);
          }
          word = words.pop();
        }
      });
    },
    drawChart: function drawChart() {
      var _this3 = this;

      var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])('#container');

      var toolTip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])('body').append('div').attr('class', 'tooltip').attr('opacity', 0);

      container.selectAll('rect').data(this.data).enter().append('rect').attr('fill', this.barColor).on('mousemove', function (d) {
        toolTip.transition().duration(200).style('opacity', 1);
        toolTip.html(_this3.tipLabel + ': <b>' + d[_this3.domain.y] + '</b>').style('left', event.pageX + 'px').style('top', event.pageY - 30 + 'px');
      }).on('mouseout', function () {
        toolTip.transition().duration(500).style('opacity', 0);
      });
      container.append('g').attr('class', 'axis x');

      container.append('g').attr('class', 'axis y');
    },
    updateChart: function updateChart() {
      var _this4 = this;

      var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])('#container');
      var x = this.scales.x;
      var y = this.scales.y;
      var height = this.padded.height;
      var xAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_axis__["a" /* axisBottom */])(x);

      container.selectAll('rect').data(this.data).attr('x', function (d) {
        return x(d[_this4.domain.x]);
      }).attr('y', height).attr('width', x.bandwidth()).attr('height', 0).transition().delay(function (d, i) {
        return i * 20;
      }).duration(800).attr('y', function (d) {
        return y(d[_this4.domain.y]);
      }).attr('height', function (d) {
        return height - y(d[_this4.domain.y]);
      });

      container.select('.x.axis').attr('transform', 'translate(0, ' + height + ')').call(xAxis).selectAll('.tick text').call(this.wrap, x.bandwidth());

      container.select('.y.axis').call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_axis__["b" /* axisLeft */])(y));
    },
    init: function init() {
      if (!this.data.length) return;
      this.drawChart();
      this.onResize();
    }
  }
});

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Loader__);
//
//
//
//
//
//
//
//
//
//





// eslint-disable-next-line



var props = {
  data: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  margin: {
    type: Object,
    default: function _default() {
      return {
        left: 30,
        right: 20,
        top: 10,
        bottom: 25
      };
    }
  },
  domain: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  keys: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  tipLabel: {
    type: String,
    default: function _default() {
      return 'value';
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grouped-bar-chart',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_5__Loader___default.a
  },
  props: props,
  data: function data() {
    return {
      width: 0,
      height: 0,
      scales: {
        color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleOrdinal */])(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* schemeCategory10 */])
      },
      resizeTimer: null
    };
  },

  computed: {
    padded: function padded() {
      var width = this.width - this.margin.left - this.margin.right;
      var height = this.height - this.margin.top - this.margin.bottom;
      return { width: width, height: height };
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      clearTimeout(_this.resizeTimer);
      _this.resizeTimer = setTimeout(_this.onResize, 550);
    });
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    data: function dataChanged() {
      this.init();
    },
    width: function widthChanged() {
      this.initialize();
      this.update();
      this.updateChart();
    }
  },
  methods: {
    onResize: function onResize() {
      this.width = this.$el.offsetWidth;
      this.height = this.width > 480 ? 400 : 360;
    },
    initialize: function initialize() {
      this.scales.x0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["c" /* scaleBand */])().rangeRound([this.padded.width, 0]).paddingInner(0.1);
      this.scales.x1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["c" /* scaleBand */])().padding(0.05);
      this.scales.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scaleLinear */])().rangeRound([0, this.padded.height]);
    },
    update: function update() {
      var _this2 = this;

      var maxY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["a" /* max */])(this.data, function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["a" /* max */])(_this2.keys, function (k) {
          return d[k];
        });
      });

      this.scales.x0.domain(this.data.map(function (d) {
        return d[_this2.domain.x];
      }));
      this.scales.x1.domain(this.keys).rangeRound([0, this.scales.x0.bandwidth()]);
      this.scales.y.domain([maxY, 0]);
    },
    wrap: function wrap(text, width) {
      text.each(function wrapText() {
        var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])(this);
        var words = t.text().split(/\s+/).reverse();
        var word = words.pop();
        var line = [];
        // eslint-disable-next-line
        var lineNumber = 0;
        var lineHeight = 1;
        var y = t.attr('y');
        var dy = parseFloat(t.attr('dy'));
        var tspan = t.text(null).append('tspan').attr('x', 0).attr('y', y).attr('dy', dy + 'em');

        while (word) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            lineNumber += 1;
            tspan = t.append('tspan').attr('x', 0).attr('y', y).attr('dy', lineNumber * lineHeight + dy + 'em').text(word);
          }
          word = words.pop();
        }
      });
    },
    drawChart: function drawChart() {
      var _this3 = this;

      var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])('#container');

      var toolTip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])('body').append('div').attr('class', 'tooltip').attr('opacity', 0);

      container.selectAll('g').data(this.data).enter().append('g').selectAll('rect').data(function (d) {
        return _this3.keys.map(function (key) {
          return { key: key, value: d[key] };
        });
      }).enter().append('rect').on('mousemove', function (d) {
        toolTip.transition().duration(200).style('opacity', 1);
        toolTip.html(_this3.tipLabel + ': <b>' + d.value + '</b>').style('left', event.pageX + 'px').style('top', event.pageY - 30 + 'px');
      }).on('mouseout', function () {
        toolTip.transition().duration(500).style('opacity', 0);
      });
      container.append('g').attr('class', 'axis x');

      container.append('g').attr('class', 'axis y');

      var legend = container.append('g').attr('text-anchor', 'end').attr('class', 'legend').selectAll('g').data(this.keys).enter().append('g').attr('transform', function (d, i) {
        return 'translate(0, ' + i * 25 + ')';
      });

      legend.append('rect').attr('class', 'legend-rect').attr('fill', this.scales.color);

      legend.append('text').attr('class', 'legend-text').text(function (d) {
        return d;
      });
    },
    updateChart: function updateChart() {
      var _this4 = this;

      var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["a" /* select */])('#container');
      var x0 = this.scales.x0;
      var x1 = this.scales.x1;
      var y = this.scales.y;
      var color = this.scales.color;
      var height = this.padded.height;
      var width = this.padded.width;

      container.selectAll('g').data(this.data).attr('transform', function (d) {
        return 'translate(' + x0(d[_this4.domain.x]) + ', 0)';
      }).selectAll('rect').data(function (d) {
        return _this4.keys.map(function (key) {
          return { key: key, value: d[key] };
        });
      }).attr('x', function (d) {
        return x1(d.key);
      }).attr('y', height).attr('width', x1.bandwidth()).attr('height', 0).attr('fill', function (d) {
        return color(d.key);
      }).transition().delay(function (d, i) {
        return i * 20;
      }).duration(800).attr('y', function (d) {
        return y(d.value);
      }).attr('height', function (d) {
        return height - y(d.value);
      });

      container.select('.x.axis').attr('transform', 'translate(0, ' + height + ')').call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_axis__["a" /* axisBottom */])(x0)).selectAll('.tick text').call(this.wrap, x0.bandwidth());

      container.select('.y.axis').call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_axis__["b" /* axisLeft */])(y));

      var legend = container.select('.legend').data(this.keys);

      legend.selectAll('.legend-rect').attr('x', width - 20).attr('width', 20).attr('height', 20);

      legend.selectAll('.legend-text').attr('x', width - 25).attr('y', 10).attr('dy', '0.32em');
    },
    init: function init() {
      if (!this.data.length) return;
      this.drawChart();
      this.onResize();
    }
  }
});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_axis__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_shape__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_selection__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_transition__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loader__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Loader__);
//
//
//
//
//
//
//
//
//
//






// eslint-disable-next-line



var props = {
  data: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  margin: {
    type: Object,
    default: function _default() {
      return {
        left: 30,
        right: 20,
        top: 10,
        bottom: 25
      };
    }
  },
  domain: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  keys: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'stacked-bar-chart',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__Loader___default.a
  },
  props: props,
  data: function data() {
    return {
      width: 0,
      height: 0,
      scales: {
        color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleOrdinal */])(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* schemeCategory10 */])
      },
      stacked: [],
      resizeTimer: null
    };
  },

  computed: {
    padded: function padded() {
      var width = this.width - this.margin.left - this.margin.right;
      var height = this.height - this.margin.top - this.margin.bottom;
      return { width: width, height: height };
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', function () {
      clearTimeout(_this.resizeTimer);
      _this.resizeTimer = setTimeout(_this.onResize, 550);
    });
    this.mungeData();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  watch: {
    data: function dataChanged() {
      this.mungeData();
    },
    width: function widthChanged() {
      this.initialize();
      this.update();
      this.updateChart();
    }
  },
  methods: {
    onResize: function onResize() {
      this.width = this.$el.offsetWidth;
      this.height = 400;
    },
    initialize: function initialize() {
      this.scales.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["c" /* scaleBand */])().rangeRound([this.padded.height, 0]).padding(0.2);
      this.scales.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scaleLinear */])().rangeRound([0, this.padded.width]);
    },
    update: function update() {
      var _this2 = this;

      var maxY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["a" /* max */])(this.stacked, function (data) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_array__["a" /* max */])(data, function (d) {
          return d[1];
        });
      });

      this.scales.x.domain(this.data.map(function (d) {
        return d[_this2.domain.x];
      }));
      this.scales.y.domain([0, maxY]);
    },
    drawChart: function drawChart() {
      var _this3 = this;

      var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_selection__["a" /* select */])('#container');

      var toolTip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_selection__["a" /* select */])('body').append('div').attr('class', 'tooltip').attr('opacity', 0);

      container.selectAll('.layer').data(this.stacked, function (d) {
        return d.key;
      }).enter().append('g').attr('class', 'layer').attr('fill', function (d) {
        return _this3.scales.color(d.key);
      }).selectAll('rect').data(function (d) {
        return d;
      }).enter().append('rect').on('mousemove', function (d) {
        toolTip.transition().duration(200).style('opacity', 1);
        toolTip.html('count: <b>' + (d[1] - d[0]) + '</b>').style('left', event.pageX + 'px').style('top', event.pageY - 30 + 'px');
      }).on('mouseout', function () {
        toolTip.transition().duration(500).style('opacity', 0);
      });
      container.append('g').attr('class', 'axis x');

      container.append('g').attr('class', 'axis y');

      var legend = container.append('g').attr('text-anchor', 'end').attr('class', 'legend').selectAll('g').data(this.keys).enter().append('g').attr('transform', function (d, i) {
        return 'translate(0, ' + i * 25 + ')';
      });

      legend.append('rect').attr('class', 'legend-rect').attr('fill', this.scales.color);

      legend.append('text').attr('class', 'legend-text').text(function (d) {
        return d;
      });
    },
    updateChart: function updateChart() {
      var _this4 = this;

      var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_selection__["a" /* select */])('#container');
      var x = this.scales.x;
      var y = this.scales.y;
      var width = this.padded.width;
      var height = this.padded.height;

      container.selectAll('.layer').data(this.stacked, function (d) {
        return d.key;
      }).selectAll('rect').data(function (d) {
        return d;
      }).attr('y', function (d) {
        return x(d.data[_this4.domain.x]);
      }).attr('x', 0).attr('height', x.bandwidth()).attr('width', 0).transition().delay(function (d, i) {
        return i * 20;
      }).duration(800).attr('x', function (d) {
        return y(d[0]);
      }).attr('width', function (d) {
        return y(d[1]) - y(d[0]);
      });

      container.select('.x.axis').attr('transform', 'translate(0, ' + height + ')').call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_axis__["a" /* axisBottom */])(y));

      container.select('.y.axis').call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_axis__["b" /* axisLeft */])(x));

      var legend = container.select('.legend').data(this.keys);

      legend.selectAll('.legend-rect').attr('x', width - 20).attr('width', 20).attr('height', 20);

      legend.selectAll('.legend-text').attr('x', width - 25).attr('y', 10).attr('dy', '0.32em');
    },
    mungeData: function mungeData() {
      if (!this.data.length) return;
      var stackFunc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_d3_shape__["a" /* stack */])().keys(this.keys);
      this.stacked = stackFunc(this.data);
      this.drawChart();
      this.onResize();
    }
  }
});

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'awards-motm',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 30,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'player', y: 'count' }
    };
  },
  mounted: function mounted() {
    fetch('data/man-of-match-awards.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.sort(function (a, b) {
        return b.count - a.count;
      }).slice(0, 10).reverse();
    }
  }
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'awards-orange-caps',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 35,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'batsman', y: 'runs' },
      barColor: '#FF9800',
      tipLabel: 'runs'
    };
  },
  mounted: function mounted() {
    fetch('data/orange-caps-awards.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.reverse();
    }
  }
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'awards-orange-caps',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 30,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'bowler', y: 'wickets' },
      barColor: '#9C27B0',
      tipLabel: 'wickets'
    };
  },
  mounted: function mounted() {
    fetch('data/purple-caps-awards.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.reverse();
    }
  }
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'batsmen-total-runs',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 40,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'batsmen', y: 'totalRuns' }
    };
  },
  mounted: function mounted() {
    fetch('data/batsmen-total-runs.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.sort(function (a, b) {
        return b.totalRuns - a.totalRuns;
      }).slice(0, 10).reverse();
    }
  }
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'batsmen-boundries',
  components: { GroupedBarChart: __WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 35,
        right: 10,
        top: 15,
        bottom: 30
      },
      domain: { x: 'batsman' },
      keys: ['fours', 'sixes']
    };
  },
  mounted: function mounted() {
    fetch('data/batsmen-fours-and-sixes.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.slice(0, 10).reverse();
    }
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'batsmen-individual-scores',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 35,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'batsmen', y: 'score' },
      tipLabel: 'score',
      barColor: '#66BB6A'
    };
  },
  mounted: function mounted() {
    fetch('data/batsmen-individual-scores.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.slice(0, 10).reverse();
    }
  }
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bowler-economy',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 25,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'bowler', y: 'economy' }
    };
  },
  mounted: function mounted() {
    fetch('data/bowler-overs-and-runs.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.map(function (row) {
        return {
          bowler: row.bowler,
          economy: (row.runs / row.overs).toFixed(3)
        };
      }).sort(function (a, b) {
        return a.economy - b.economy;
      }).slice(0, 10).reverse();
    }
  }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_BarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bowler-total-wickets',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_0__charts_BarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 35,
        right: 5,
        top: 15,
        bottom: 30
      },
      domain: { x: 'bowler', y: 'wickets' },
      barColor: '#66BB6A'
    };
  },
  mounted: function mounted() {
    fetch('data/bowler-wickets.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.sort(function (a, b) {
        return b.wickets - a.wickets;
      }).slice(0, 10).reverse();
    }
  }
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_GroupedBarChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_GroupedBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__charts_GroupedBarChart__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'batsmen-boundries',
  components: { GroupedBarChart: __WEBPACK_IMPORTED_MODULE_2__charts_GroupedBarChart___default.a },
  data: function data() {
    return {
      data: [],
      margin: {
        left: 30,
        right: 10,
        top: 15,
        bottom: 40
      },
      domain: { x: 'team' },
      keys: ['played', 'wins'],
      tipLabel: 'count'
    };
  },
  mounted: function mounted() {
    fetch('data/season-finals.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      var finals = response.reduce(function (acc, row) {
        if (!acc[row.team1]) acc[row.team1] = { played: 0, wins: 0 };
        if (!acc[row.team2]) acc[row.team2] = { played: 0, wins: 0 };
        acc[row.team1].played += 1;
        acc[row.team2].played += 1;
        acc[row.winner].wins += 1;
        return acc;
      }, {});

      this.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(finals).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            team = _ref2[0],
            obj = _ref2[1];

        var played = obj.played;
        var wins = obj.wins;
        return { team: team, played: played, wins: wins };
      }).sort(function (a, b) {
        return a.played - b.played;
      });
    }
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teams-by-boundries',
  components: { GroupedBarChart: __WEBPACK_IMPORTED_MODULE_0__charts_GroupedBarChart___default.a },
  data: function data() {
    return {
      margin: { left: 40, right: 10, top: 15, bottom: 30 },
      data: [],
      domain: { x: 'teamAbbr' },
      keys: ['fours', 'sixes']
    };
  },
  mounted: function mounted() {
    fetch('data/team-fours-and-sixes.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.sort(function (a, b) {
        return b.fours + b.sixes - (a.fours + a.sixes);
      }).reverse();
    }
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_StackedBarChart__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_StackedBarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_StackedBarChart__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teams-by-wins',
  components: { StackedBarChart: __WEBPACK_IMPORTED_MODULE_0__charts_StackedBarChart___default.a },
  data: function data() {
    return {
      margin: { left: 35, right: 20, top: 10, bottom: 25 },
      data: [],
      keys: ['total', 'wins'],
      domain: { x: 'teamAbbr' },
      tipLabel: 'matches'
    };
  },
  mounted: function mounted() {
    fetch('data/team-matches-vs-wins.json').then(function (res) {
      return res.json();
    }).then(this.mungeData).catch(function (e) {
      return console.error(e);
    });
  },

  methods: {
    mungeData: function mungeData(response) {
      this.data = response.sort(function (a, b) {
        return b.wins - a.wins;
      });
    }
  }
});

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ipl-logo.59800d7.png";

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(392),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(397),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(400),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(391),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(398),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(389),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(404),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(394),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-box"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "ripple one"
  }), _vm._v(" "), _c('div', {
    staticClass: "ripple two"
  }), _vm._v(" "), _c('div', {
    staticClass: "ripple three"
  }), _vm._v(" "), _c('div', {
    staticClass: "ripple four"
  })])])
}]}

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.data.length) ? _c('Loader') : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "chart",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    style: ({
      transform: ("translate(" + (_vm.margin.left) + "px, " + (_vm.margin.top) + "px)")
    }),
    attrs: {
      "id": "container"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('grouped-bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "keys": _vm.keys,
      "tip-label": _vm.tipLabel
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Season Final Analysis")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes teams by:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(" IPL Final Appearences ")]), _vm._v(" "), _c('li', [_vm._v(" IPL Final Wins ")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chennai Super Kings have the most final appearences at 6.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Kolkata Knight Riders have won 2 out of 2 finals.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Mumbai Indians, Kolkata Knight Riders and Chennai Super Kings have won\n        2 titles each, making them the most successful teams.\n      ")])])])
}]}

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.data.length) ? _c('Loader') : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "chart",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    style: ({
      transform: ("translate(" + (_vm.margin.left) + "px, " + (_vm.margin.top) + "px)")
    }),
    attrs: {
      "id": "container"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "tip-label": _vm.tipLabel,
      "bar-color": _vm.barColor
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Batsmen: By Individual Scores")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 batsmen with highest individual score in an\n      IPL match across all seasons.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chris Gayle of Royal Challengers Banglore leads the chart with a massive\n        score of 175 runs, scored against Pune Warriors.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        CH Gayle has 3 entries in top 10, followed by AB de Villiers and Virender Sehwag,\n        both at 2 entries.\n      ")])])])
}]}

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      'sidebar-open': _vm.isSideBarOpen
    }
  }, [_c('img', {
    staticClass: "logo hide-md",
    attrs: {
      "src": __webpack_require__(372),
      "alt": "ipl logo"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn back-btn show-md",
    on: {
      "click": _vm.closeSideBar
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/'
      },
      "exact": ""
    }
  }, [_vm._v("\n    Home\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/finals'
      }
    }
  }, [_vm._v("\n    Season Finals\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Top Teams")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/team-wins'
      }
    }
  }, [_vm._v("\n      by Wins\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/team-boundries'
      }
    }
  }, [_vm._v("\n      by Boundries\n    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Top Batsmen")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/batsmen-total-runs'
      }
    }
  }, [_vm._v("\n      by Runs\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/batsmen-individual-scores'
      }
    }
  }, [_vm._v("\n      by Scores\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/batsmen-boundries'
      }
    }
  }, [_vm._v("\n      by Boundries\n    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Top Bowlers")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/bowler-total-wickets'
      }
    }
  }, [_vm._v("\n      by Wickets\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/bowler-economy'
      }
    }
  }, [_vm._v("\n      by Economy\n    ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn collapse-btn",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Player Awards")]), _vm._v(" "), _c('div', {
    staticClass: "collapse-panel"
  }, [_c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/awards-motm'
      }
    }
  }, [_vm._v("\n      Man of Match\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/awards-orange-caps'
      }
    }
  }, [_vm._v("\n      Orange Caps\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "sidebar-link",
    attrs: {
      "to": {
        path: '/awards-purple-caps'
      }
    }
  }, [_vm._v("\n      Purple Caps\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "barColor": _vm.barColor
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Bowlers: By Wickets")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 bowlers by total number of wickets taken\n      across all IPL seasons.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Lasith Malinga of Mumbai Indians leads the chart with 143 wickets taken.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Amit Mishra of Delhi Daredevils comes second with 124 wickets.\n      ")])])])
}]}

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('stacked-bar-chart', {
    attrs: {
      "data": _vm.data,
      "margin": _vm.margin,
      "keys": _vm.keys,
      "tip-label": _vm.tipLabel,
      "domain": _vm.domain
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Teams: Matches Vs Wins")]), _vm._v(" "), _c('p', [_vm._v("This chart visualizes the IPL teams across all seasons based on")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Total Matches Played")]), _vm._v(" "), _c('li', [_vm._v("Total Match Wins")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Mumbai Indian have the highest number of match wins among all other teams\n        at 80 matches.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Chennai super kings are the second most successful side in IPL behind Mumbai\n        Indians.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Both Teams have won 2 IPL titles each.\n      ")])])])
}]}

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(!_vm.data.length) ? _c('Loader') : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "chart",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('g', {
    style: ({
      transform: ("translate(" + (_vm.margin.left) + "px, " + (_vm.margin.top) + "px)")
    }),
    attrs: {
      "id": "container"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Man of the Match Awards")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 players the have won the most Man of the Match\n      awards across all seasons of IPL.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Man of the Match Awards is given after each match to the best performer.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chris Gayle leads the list, being awarded the MOTM 17 times in IPL.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Yusuf pathan and AB de Villiers follow with 16 and 15 MOTM awards\n        respectively.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Sadly, no bowlers make it to the top 10 list.\n      ")])])])
}]}

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "barColor": _vm.barColor,
      "tip-label": _vm.tipLabel
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Purple Cap Awards")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes all the Purple cap winners in IPL from (2008-2016)\n      in left-to-right direction.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Purple Cap is awarded to the Bowler with most wickets at the end of every\n      IPL season.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Dwayne Bravo has won the purple cap twice, in 2013 & 2015.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Dwayne Bravo took the most wickets(32) in 2011, most for any purple\n        cap winner.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        RP singh in 2009, Mohit Sharma in 2014 and Bhuvneshwar Kumar in 2016,\n        won the purple cap with exact same wicket haul(23).\n      ")])])])
}]}

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Bowlers: By Economy")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 most economical bowlers across all seasons\n      of IPL.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Economy = Total Runs Conceded / Total Overs Bowled.\n    ")]), _vm._v(" "), _c('small', [_vm._v("** Only bowlers that have bowled 300+ overs are included.")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Lasith Malinga of Mumbai Indians is the most economical bowler across\n        all seasons on IPL with an economy of 6.349.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Ravichandran Ashwin comes second with a small margin at 6.359.\n      ")])])])
}]}

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Batsmen: Total Runs")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 batsmen with most runs scored across all\n      the seasons of IPL.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Virat Kohli of Royal Challengers Banglore has scored 4115 runs, the most\n        for any batsman in IPL.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Suresh Raina of Chennai Super kings is second on the list by a difference of\n        only 9 runs at 4106.\n      ")])])])
}]}

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('grouped-bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "keys": _vm.keys
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Batsmen: By Boundries")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 batsmen by:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(" Total Sixes Hit ")]), _vm._v(" "), _c('li', [_vm._v(" Total Fours Hit ")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chris Gayle of Royal Challengers Banglore has the most sixes at 247, and\n        he leads by a huge margin.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Gautam Gambhir of Kolkata Knight Riders has the most fours at 427.\n      ")])])])
}]}

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "barColor": _vm.barColor,
      "tip-label": _vm.tipLabel
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Orange Cap Awards")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes all the orange cap winners in IPL from (2008-2016)\n      in left-to-right direction.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Orange Cap is awarded to the Batsman with most runs at the end of\n      every IPL season.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Virat Kohli won the award in 2016 by scoring 973 runs, highest for any\n        orange cap winner.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Chris Gayle has won orange cap twice & consecutively, in 2011 and 2012.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Chris Gayle in 2012 and Mike Hussey in 2013 both scored the same amount\n        of runs(733) to win the orange cap.\n      ")])])])
}]}

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "primary"
  }, [_vm._v("Awesome IPL dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n    The Indian Premier League is a professional Twenty20 cricket league in\n    India contested during April and May of every year by teams representing\n    Indian cities.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n    Awesome IPL dashboard is a collection of visualizations and trivia\n    of IPL data from 2008 to 2016 season.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/finals'
      }
    }
  }, [_vm._v("\n        Season Finals\n      ")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/batsmen-total-runs'
      }
    }
  }, [_vm._v("\n        Top Batsmen\n      ")]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/bowler-total-wickets'
      }
    }
  }, [_vm._v("\n        Top bowlers\n      ")]), _vm._v(" "), _vm._m(2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-4 col-offset-2"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/awards-motm'
      }
    }
  }, [_vm._v("\n        Player Awards\n      ")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-4"
  }, [_c('router-link', {
    staticClass: "sidebar-link btn-link",
    attrs: {
      "to": {
        path: '/team-wins'
      }
    }
  }, [_vm._v("\n        Top Teams\n      ")]), _vm._v(" "), _vm._m(4)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Which team has won the IPL "), _c('b', [_vm._v("most times")]), _vm._v("? Which team is most likely to reach\n        an IPL final "), _c('b', [_vm._v("every year")]), _vm._v("?\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Visualizations of top IPL Batsmen based on "), _c('b', [_vm._v("Runs scored")]), _vm._v(", "), _c('b', [_vm._v("Individual scores")]), _vm._v("\n        & "), _c('b', [_vm._v("4's and 6's scored")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Visualizations of top IPL Bowlers based on "), _c('b', [_vm._v("Wickets taken")]), _vm._v(", "), _c('b', [_vm._v("Over's bowled")]), _vm._v("\n        & "), _c('b', [_vm._v("Bowling economy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Who has won most "), _c('b', [_vm._v("Man of the Match")]), _vm._v(" awards,\n        "), _c('b', [_vm._v("Orange Caps")]), _vm._v(" Or "), _c('b', [_vm._v("Purple Caps")]), _vm._v(" across the seasons?\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        Visualizations of top IPL teams based on "), _c('b', [_vm._v("Total wins")]), _vm._v(", "), _c('b', [_vm._v("Matches vs Wins")]), _vm._v("\n        & "), _c('b', [_vm._v("4's and 6's scored")])])
}]}

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('sidebar', {
    attrs: {
      "isSideBarOpen": _vm.isSideBarOpen
    },
    on: {
      "close": _vm.closeSidebar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    class: {
      overlay: _vm.isSideBarOpen
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('svg', {
    staticClass: "ham-icon",
    attrs: {
      "height": "32px",
      "width": "32px"
    },
    on: {
      "click": _vm.openSidebar
    }
  }, [_c('path', {
    attrs: {
      "d": "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,\n          8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,\n          0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,\n          2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
    }
  })]), _vm._v("\n      Awesome IPL\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fixed"
  }, [_c('router-view')], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('grouped-bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "keys": _vm.keys
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Teams: Boundries")]), _vm._v(" "), _c('p', [_vm._v("This chart visualizes the IPL teams across all seasons based on")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Total Sixes Hit")]), _vm._v(" "), _c('li', [_vm._v("Total Fours Hit")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Royal Challengers Banglore appears to be the most explosive side in IPL\n        with highest number of sixes scored.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Mumbai Indians have scored the most fours for a IPL side.\n      ")])])])
}]}

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(387),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(395),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[144]);


// WEBPACK FOOTER //
// static/js/app.c0f5456beb40dd45df25.js